module.exports = __webpack_public_path__ + "6c6b49373ee7e518531bd7b68b847686.svg";